import * as React from "react";
import { FC } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery, useTheme } from "@mui/material";
import { processListType } from "../../../singleInput/detail/item/SingleInputItem";
const classes = {
  statusMenu: {
    "& .MuiOutlinedInput-input": {
      paddingBottom: "7px",
      paddingTop: "7px",
    },
  },
};
type DateSelectorProps = {
  label: string;
  value: string;
  options: { id: string; name: string }[] | processListType[];
  select: (value: string) => void;
  required: boolean;
  disabled: boolean;
  width: string;
  height: string;
  fontSize: string;
  setMode: string;
  colorMode: string;
  readOnly?: boolean;
};

const SelectBoxForString: FC<DateSelectorProps> = (props) => {
  const user = useRecoilValue(userState);
  const theme = useTheme();
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <FormControl
      variant="standard"
      sx={{
        // width: props.width,
        width: isIphone ? props.width : `calc(${props.width} * 1.4)`,

        // marginBottom: "10px",
      }}
    >
      {props.label !== "" && (
        <InputLabel sx={{ color: theme.palette.foreColor.main }}>
          {props.label}
        </InputLabel>
      )}
      <Select
        readOnly={props.readOnly}
        disabled={props.disabled}
        required={props.required}
        value={props.value}
        onChange={(event) => props.select(event.target.value as string)}
        // onChange={(event) => props.select(event.target.value)}
        // IconComponent={() => (
        //   <ArrowDropDownIcon
        //     style={{
        //       color: foreColorCode(user?.mode ?? "dark"),
        //       cursor: "pointer",
        //     }}
        //   />
        // )}
        label={props.label} // MUI v5では、選択した値とラベルを適切に揃えるためにこれを追加する必要があるかもしれません
        sx={{
          color:
            props.colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          height: props.height,
          paddingLeft: "10px",
          fontSize: props.fontSize,
          "& .MuiSvgIcon-root": {
            color:
              props.colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
          },
          "&icon": {
            color: "blue",
          },
          borderRadius: "5px",
          backgroundColor:
            props.colorMode === "light"
              ? theme.palette.backColor.main
              : theme.palette.backColor.dark, // 選択エリアの背景色を設定
          "& .MuiSelect-select": {
            color:
              props.colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
            backgroundColor:
              props.colorMode === "light"
                ? theme.palette.backColor.main
                : theme.palette.backColor.dark, // 選択エリアの背景色を設定
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{
              fontSize: "0.8rem",
              color:
                props.colorMode === "light"
                  ? theme.palette.foreColor.main
                  : theme.palette.foreColor.light,
              backgroundColor:
                props.colorMode === "light"
                  ? theme.palette.backColor.main
                  : theme.palette.backColor.dark, // メニューエリアの背景色を設定
              // 選択された状態のスタイル
              "&.Mui-selected": {
                backgroundColor:
                  props.colorMode === "light"
                    ? theme.palette.backColor.main
                    : theme.palette.backColor.dark, // 選択時の背景色を変更
                color:
                  props.colorMode === "light"
                    ? theme.palette.foreColor.light
                    : theme.palette.foreColor.main, // 選択時の文字色を変更
              },

              // ホバー状態のスタイルも定義できます
              "&:hover": {
                backgroundColor:
                  props.colorMode === "light"
                    ? theme.palette.backColor.main
                    : theme.palette.backColor.dark, // ホバー時の背景色を変更
                color:
                  props.colorMode === "light"
                    ? theme.palette.foreColor.light
                    : theme.palette.foreColor.main, // ホバー時の文字色を変更
              },
              // 選択されていてさらにホバーされた状態のスタイル
              "&.Mui-selected:hover": {
                backgroundColor:
                  props.colorMode === "light"
                    ? theme.palette.backColor.main
                    : theme.palette.backColor.dark, // 選択 + ホバー時の背景色
                color:
                  props.colorMode === "light"
                    ? theme.palette.foreColor.light
                    : theme.palette.foreColor.main, // 選択 + ホバー時の文字色
              },
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxForString;
